import type {SelectedDay} from '@date-picker';
import type {CpcBuyFilters} from 'modules/Cpc/Buy/types';

import {InfoCircleOutlined} from '@ant-design/icons';
import {convertJalaliToGregorian, dateToReadableDate, MonthCalendar} from '@date-picker';
import CpcInfoRow from 'modules/Cpc/components/common/CpcInfoRow/CpcInfoRow';
import moment from 'moment-jalaali';
import {useEffect, useState} from 'react';

type RangePickerStepProps = {
  filters: CpcBuyFilters;
  setFilters: (filters: CpcBuyFilters) => void;
};

const RangePickerStep: React.FC<RangePickerStepProps> = ({filters, setFilters}) => {
  const currentDay = moment().jDate();
  const currentMonth = moment().jMonth();
  const currentYear = moment().jYear();
  const [selectedDate, setSelectedDate] = useState<SelectedDay>({
    day: 1,
    dayKey: filters.dayKey ?? `current-${currentDay + 1}`,
    date: null
  });

  useEffect(() => {
    if (!filters.date) {
      setFilters({
        ...filters,
        day: currentDay,
        dayKey: `current-${currentDay + 1}`,
        date: convertJalaliToGregorian(`${currentYear}-${currentMonth + 1}-${currentDay + 1}`)
      });
    }
    // The default date must only be initialized on the first mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDateChange = (selection: SelectedDay) => {
    setFilters({
      ...filters,
      day: selection.day,
      dayKey: selection.dayKey,
      date: selection.date ?? undefined
    });
  };

  return (
    <div className="flex min-h-0 flex-1 flex-col justify-between">
      <div>
        <MonthCalendar
          month={currentMonth}
          selectedDay={selectedDate.day}
          selectedDayKey={selectedDate.dayKey}
          setter={setSelectedDate}
          filterSetter={handleDateChange}
          currentDay={currentDay}
          enableDaysCount={7}
        />
        <div className="mx-2.5 mt-3 flex min-h-25 items-center gap-2.5 rounded-xl bg-yellow-soft p-3 text-justify text-body-sm text-gray-08">
          <InfoCircleOutlined className="shrink-0 text-body-lg text-yellow-dark-03" aria-hidden />
          <p>
            انتخاب و خرید بازدید بیشتر (کلیک)، برای روز جاری امکان‌پذیر نیست. نزدیک‌ترین تاریخ ممکن
            برای شرکت در کمپین بازدید بیشتر، یک روز بعد است.
          </p>
        </div>
      </div>

      {filters.date ? (
        <CpcInfoRow
          title="تاریخ"
          value={dateToReadableDate({
            date: filters.date,
            day: true,
            month: true,
            year: true
          })}
        />
      ) : null}
    </div>
  );
};

export default RangePickerStep;
